import { useI18N } from '../../../libraries/i18n/hook'
export { default as AiInterview } from './AiInterview'
export { default as CVRoaster } from './CVRoaster'
export { default as AdvisorAI } from './AdvisorAI'
import BehaviouralResources from '../../components/ai-interviewer/BehaviouralResources'
import { INTERVIEW_TOPICS, Topic } from './types'
export { JobOfferCVRoaster, JobOfferAiInterview } from './job-offer'

export const getTopics = (topics: Array<{ value: INTERVIEW_TOPICS, numberOfFollowUps?: number }>): Record<INTERVIEW_TOPICS, Topic> => {
  const { t } = useI18N()

  const ALL_TOPICS = {
    [INTERVIEW_TOPICS.CUSTOM]: { label: 'Custom interview', description: t('interviewer.ai.topic.custom-interview.description'), numberOfQuestions: 3, numberOfFollowUps: 2, expectedTime: '15-20 min', resourcesComponent: null, dynamic: true },
    [INTERVIEW_TOPICS.BEHAVIOURAL]: { label: 'Behavioural', description: t('interviewer.ai.topic.behavioural.description'), numberOfQuestions: 1, numberOfFollowUps: 3, expectedTime: '10-15 min', resourcesComponent: BehaviouralResources },
    [INTERVIEW_TOPICS.FIT]: { label: 'FIT Interview', description: t('interviewer.ai.topic.fit-interview.description'), numberOfQuestions: 1, numberOfFollowUps: 3, expectedTime: '15-20 min', resourcesComponent: null },
    [INTERVIEW_TOPICS.DATA_SCIENCE]: { label: 'Data Science', description: t('interviewer.ai.topic.data-science.description'), numberOfQuestions: 3, numberOfFollowUps: 2, expectedTime: '15-20 min', resourcesComponent: null },
  }

  return topics.reduce((acc, topic) => ({ ...acc, [topic.value]: { ...ALL_TOPICS[topic.value], ...topic } }), {} as Record<INTERVIEW_TOPICS, Topic>)
}

